export default "__VITE_ASSET__Bln1509a__"